import React from 'react';

class ConfirmationPopup extends React.Component
{
  render()
  {
    return (

      <div className='confirmation-popup-container colour-light-shade-bg colour-dark-shade rounded-floating-element' >
        <div className='confirmation-popup-title'>
          { this.props.title }
        </div>
        <div className='confirmation-popup-main-text'>
          { this.props.body }
        </div>

        <button className='confirmation-popup-confirm-button colour-danger-bg'
          onClick={ () =>
          {
            this.props.onConfirm();
            this.props.close();
          } }
        >
          { this.props.buttonText }
        </button>

      </div>
    );
  }
}

export default ConfirmationPopup;
